
const ARROW_UP_ICON = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="{0}" height="{1}" fill="{2}">
    <polygon points="9 3.828 2.929 9.899 1.515 8.485 10 0 10.707 .707 18.485 8.485 17.071 9.899 11 3.828 11 20 9 20 9 3.828"/>
</svg>
`

export {
    ARROW_UP_ICON
}